export default {
  fi: {
    ReminderEditScene: {
      confirmDelete: 'Haluatko varmasti poistaa muistutuksen?',
      editReminder: 'Muokkaa muistutusta',
    },
  },
};
